import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import "/src/assets/scss/style.scss"
import { createApp } from 'vue'
import App from '/src/App.vue'
import router from './router'

import { isNativeApp, appVersionInfo, appVersionUpdateAlert } from "./assets/js/common"
import { appStoreLInk } from "./assets/js/model"


const ftapp = createApp(App)

router.afterEach((to) => {
  if (typeof gtag === 'function') {
    gtag('config', 'G-SVEHW3R15W', {
      page_path: to.fullPath
    });
  }
});

ftapp.config.globalProperties.window = window
window.vgHost = 'chat3-ec.chatdealer.jp'
window.vgProtocol = 'https'
window.vgPort = '443'
window.vgAtxt = 'PMR37Chat3-ec'
window.vgSid = 1

// アプリでバージョンチェック完了して下記のFunctionが行う
window.appVersionCheckingResult = (require) => {
    appVersionInfo.versionCheckFinished = true
    appVersionInfo.updateRequired = require

    if(require){
        appVersionUpdateAlert()
    }
}
const isProduction = window.location.hostname === 'f-premium.jp'
if (isProduction) {
  const script1 = document.createElement('script')
  script1.async = true
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-SVEHW3R15W'
  document.head.appendChild(script1)

  const script2 = document.createElement('script')
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){ dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'G-SVEHW3R15W');
  `
  document.head.appendChild(script2)
}
ftapp.use(router)

// Nativeアプリ（iPhone, android）でもウェブビューで利用するのでアプリかどうか確認
isNativeApp.value = ( window.ftGroupAppJsBridge || (window.webkit && window.webkit.messageHandlers.appVersionChecking) ) ? true : false

// Nativeアプリ（iPhone, android）の場合
if(isNativeApp.value){
    setTimeout(() => {  
        ftapp.mount('#ftapp')
    },1000)
}
// ウェブサイトの場合
else{
    ftapp.mount('#ftapp')
}
